import React from 'react';

import  TisbWorkShop2025  from 'views/TisbWorkShop2025';
const BlogNewsroomPage = () => {

return <TisbWorkShop2025/>
};

export default BlogNewsroomPage;